/**
 * Strategy that defines what will happen if an imported reply template has a name that is not unique.
 * Skip: The template will not be imported if there is already a template with the same name.
 * Overwrite: The template text of the existing template will be overwritten by the imported one.
 */
export enum DuplicateNameStrategy {
  SKIP = 'SKIP',
  OVERWRITE = 'OVERWRITE',
  NONE = 'NONE'
}